<template>
    <a class="arrow-animation flex justify-center cursor-pointer">
        <i class="fas fa-chevron-down"></i>
        <i class="fas fa-chevron-down"></i>
    </a>
</template>

<script>
export default {}
</script>

<style lang="scss">
.arrow-animation {
    position: fixed;
    bottom: 8px;
    left: 50%;
    transform: translateX(-50%);
    width: 30px;
    height: 40px;

    @media screen and (max-width: 575px) {
        left: unset;
        right: 0;
    }

    i {
        position: absolute;
        font-size: 32px;
        color: var(--ui-color);
        animation-name: arrow;
        animation-duration: 1.4s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
        pointer-events: none;

        &:first-child {
            top: -4px;
            animation-delay: 0.2s;
        }

        &:last-child {
            top: 12px;
        }
    }
}

@keyframes arrow {
    0% {
        opacity: 1;
        transform: translateY(0px) scale(1);
    }
    25% {
        opacity: 0;
        transform: translateY(10px) scale(0.9);
    }
    26% {
        opacity: 0;
        transform: translateY(-10px) scale(0.9);
    }
    55% {
        opacity: 1;
        transform: translateY(0px) scale(1);
    }
}
</style>
